function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 9h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm0 6h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2zm0 6h26a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2z"
});

var SvgMenuMain = function SvgMenuMain(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "0de7d99eecbc6e6bdb72bfa3387babdb.svg";
export { SvgMenuMain as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/menu-main.svg
// module id = null
// module chunks = 